import { styled } from "../../styles";

export const ButtonStyled = styled("div", {
  padding: 0,
  border: "none",
  borderRadius: "$8",

  "&:focus-visible": {
    outline: "none",
  },
});

export const ButtonText = styled("p", {
  margin: 0,
  padding: 0,
});

export const ButtonContainer = styled("button", {
  // EN-5191: minHeight, not height, and the label never wraps. Every label here is two or three
  // words that belong on one line; with a fixed height a longer translation wrapped and the
  // second line was clipped inside the button ("Deelnemen aan afspraak"). Letting the button
  // size itself to its text is the only version of this that works in every language.
  minHeight: "$13",
  padding: "0 $13",
  whiteSpace: "nowrap",

  borderRadius: "20px",
  border: "2px solid var(--colors-button-border)",

  backgroundColor: "var(--colors-button-background)",
  boxSizing: "border-box",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "var(--colors-button-text)",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus-visible": {
    outline: "none",
    border: "2px solid var(--colors-button-focus-border)",
  },

  "&:focus": {
    outline: "none",
    border: "2px solid var(--colors-button-focus-border)",
  },

  "&:hover": {
    backgroundColor: "var(--colors-button-hover-background)",
    border: "2px solid var(--colors-button-hover-border)",
  },

  "&:active": {
    backgroundColor: "var(--colors-button-active-background)",
  },

  variants: {
    disabledStyle: {
      true: {
        opacity: 0.38,

        color: "var(--colors-button-disabled-text)",
        cursor: "not-allowed",
      },
    },

    isLoading: {
      true: {
        padding: "$4 $9 $4 $8",

        cursor: "not-allowed",

        backgroundColor: "var(--colors-button-loading-background)",
        border: "2px solid var(--colors-button-loading-border)",

        "&:hover": {
          backgroundColor: "var(--colors-button-loading-hover-background)",
          border: "2px solid var(--colors-button-loading-hover-border)",
        },
      },
    },

    variant: {
      secondary: {
        backgroundColor: "$black",
        border: "2px solid $black",

        "&:hover": {
          backgroundColor: "$charcoal",
          border: "2px solid $charcoal",
        },

        "&:active": {
          backgroundColor: "$gray-90",
          border: "2px solid $gray-90",
        },
      },
    },

    size: {
      small: {
        minHeight: "26px",
        padding: "0 12px",

        fontSize: "$text-md",
        lineHeight: "16px",
      },
    },
  },

  compoundVariants: [
    {
      variant: "secondary",
      isLoading: true,
      css: {
        backgroundColor: "$gray-90",
        border: "2px solid $gray-90",

        "&:hover": {
          backgroundColor: "$gray-90",
          border: "2px solid $gray-90",
        },
      },
    },
    {
      variant: "secondary",
      disabledStyle: true,
      css: {
        backgroundColor: "$black",
        border: "2px solid $black",

        "&:hover": {
          backgroundColor: "$black",
          border: "2px solid $black",
        },

        "&:active": {
          backgroundColor: "$black",
          border: "2px solid $black",
        },
      },
    },
    {
      size: "small",
      isLoading: true,
      css: {
        padding: "0 18px 0 12px",
      },
    },
  ],
});
